import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import moment from "moment";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AddItems from "../AddItems/AddItems";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ItemsBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      dialogOpen: false,
      notificationOpen: false,
      itemId: "",
      loading: false,
    };
  }

  handleEditStatus = (editStatus, itemData) => {
    if (editStatus === false) {
      this.setState({ editStatus });
    } else {
      this.setState({
        editStatus,
        itemId: itemData._id,
      });
      this.props.handleEditData(itemData);
    }
  };

  handleDialogOpen = (itemId) => {
    this.setState({
      dialogOpen: true,
      itemId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteItem = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/item-categories/${this.props.categoryId}/item/${this.state.itemId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Item deleted successfully") {
        this.props.getCategoryDetails(this.props.categoryId);
        this.handleDialogClose();
        this.handleNotificationOpen();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteItem();
      }
    }
  };

  handleEdit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      const response = await Axios.put(
        `${url}/api/item-categories/${this.props.categoryId}/item/${this.state.itemId}`,
        this.props.itemData,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.message === "Item updated successfully") {
        this.handleEditStatus(false);
        this.props.getCategoryDetails(this.props.categoryId);
      }
    } catch (error) {
      this.setState({ loading: true });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEdit(e);
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow key={index}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.itemName}</TableCell>
        <TableCell align="center">{data.quantity}</TableCell>
        <TableCell align="center">Rs. {data.rate}</TableCell>
        <TableCell align="center">
          Rs. {parseFloat(data.quantity * data.rate)}
        </TableCell>
        <TableCell align="center">{data.purchasedFrom}</TableCell>
        <TableCell align="center">
          {moment(data.purchasedDate).format("LL")}
        </TableCell>

        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditStatus(true, data)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteItem}
        />
      </TableRow>
    ) : (
      <AddItems
        loading={this.state.loading}
        index={index}
        editStatus={true}
        itemData={this.props.itemData}
        handleEditStatus={this.handleEditStatus}
        handleChange={this.props.handleChange}
        handleEdit={this.handleEdit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ItemsBody)));
